import { render, staticRenderFns } from "./Qualificationmanagement.vue?vue&type=template&id=343e387c&scoped=true&"
import script from "./Qualificationmanagement.vue?vue&type=script&lang=js&"
export * from "./Qualificationmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Qualificationmanagement.vue?vue&type=style&index=0&id=343e387c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e387c",
  null
  
)

export default component.exports